import { Icon } from '@studio/design-system/icon';
import type { HtmlAttributes } from '@studio/design-system/props';
import { clsx } from 'cn';
import type { ReactElement } from 'react';
import { useState } from 'react';
import { twMerge } from 'cn';
import { Column, Exhibit } from './styled.jsx';
import { Command, Lang } from '#~/command/index.js';
import * as Combo from '#~/hot-keys/components/combo/index.js';
import { DefaultHotKeys, Icons } from '#~/hot-keys/index.js';
import type { Action, Combo as M_Combo } from '#~/hot-keys/index.js';

/** @internal */
const Row = ({
  action,
  className,
  ...props
}: HtmlAttributes & { action: Action }): ReactElement => {
  const [combo, setCombo] = useState<M_Combo | false>(structuredClone(DefaultHotKeys[action]));
  const label = Lang[action];
  const icon = Icons[action];

  return (
    <div
      className={twMerge(
        'flex items-center gap-8 border-b border-base-100 py-8 text-muted',
        className
      )}
      {...props}
    >
      {!!icon && <Icon className='text-xl' icon={icon} />}
      <div>{label}</div>

      <div className='ml-auto'>
        <Combo.Mediator onCommit={setCombo} value={combo} />
      </div>
    </div>
  );
};

/** `<HotKeys>` exhibit. */
export const HotKeys = (): ReactElement => (
  <Exhibit title='Hot Keys'>
    <Column className='w-prompt gap-0'>
      {(
        [
          Command.TOOL_JOYSTICK,
          Command.TOOL_ZOOM,
          Command.PTZ_PAN_LEFT,
          Command.PTZ_PAN_RIGHT
        ] as Action[]
      ).map((action, index) => (
        <Row action={action} className={clsx(index === 0 && 'border-t')} key={action} />
      ))}
    </Column>
  </Exhibit>
);
